import { AppState } from '$/store';
import * as Bixby from '$/core';
import { DecodedToken } from '$/core/models';

export abstract class ProfileService {
  public static getProfileFromState(getState: () => AppState) {
    const loginState = (getState() || ({} as AppState)).loginState;
    if (Bixby.Utils.isDefined(loginState) && Bixby.Utils.isDefined(loginState.decodedToken)) {
      const token: DecodedToken = loginState.decodedToken || ({} as DecodedToken);
      const { email, given_name, family_name, role } = token;
      const isAdmin = ProfileService.findClaim(role, Bixby.Constants.LOGIN_ROLES_ADMIN);
      const isClient = ProfileService.findClaim(role, Bixby.Constants.LOGIN_ROLES_CLIENT);
      const isClientConsultant = ProfileService.findClaim(role, Bixby.Constants.LOGIN_ROLES_CLIENTCONSULTANT);
      const isDocHostingAdmin = ProfileService.findClaim(role, Bixby.Constants.LOGIN_ROLES_DOCHOSTINGADMIN);
      const isClientComplianceAdmin = ProfileService.findClaim(role, Bixby.Constants.LOGIN_ROLES_CLIENTCOMPLIANCEADMIN);
      const isBixbyComplianceAdmin = ProfileService.findClaim(role, Bixby.Constants.LOGIN_ROLES_BIXBYCOMPLIANCEADMIN);
      const isCompanyMnpiInfoAdmin = ProfileService.findClaim(role, Bixby.Constants.LOGIN_ROLES_COMPANYMNPIINFOADMIN);
      const isCompanyPublicInfoAdmin = ProfileService.findClaim(role, Bixby.Constants.LOGIN_ROLES_COMPANYPUBLICINFOADMIN);
      const isSuperAdmin = ProfileService.findClaim(role, Bixby.Constants.LOGIN_ROLES_SUPERADMIN);
      const isCreditSightsAnalyst = ProfileService.findClaim(role, Bixby.Constants.LOGIN_ROLES_CREDITSIGHTSANALYST);
      const isCreditSightsOps = ProfileService.findClaim(role, Bixby.Constants.LOGIN_ROLES_CREDITSIGHTSOPS);
      const isSufAnalyst = ProfileService.findClaim(role, Bixby.Constants.LOGIN_ROLES_SUFANALYST);
      const isRatingsAnalyst = ProfileService.findClaim(role, Bixby.Constants.LOGIN_ROLES_RATINGSANALYST);
      const isLegalAdmin = ProfileService.findClaim(role, Bixby.Constants.LOGIN_ROLES_LEGALADMIN);
      const isDataAdmin = ProfileService.findClaim(role, Bixby.Constants.LOGIN_ROLES_DATAADMIN);
      const firstName = given_name || '';
      const lastName = family_name || '';
      
      return {
        isAdmin,
        isClient,
        isClientConsultant,
        isDocHostingAdmin,
        isSuperAdmin,
        firstName,
        lastName,
        email, 
        isCreditSightsAnalyst,
        isCreditSightsOps,
        isClientComplianceAdmin,
        isBixbyComplianceAdmin,
        isCompanyMnpiInfoAdmin,
        isCompanyPublicInfoAdmin,
        isSufAnalyst,
        isRatingsAnalyst,
        isLegalAdmin,
        isDataAdmin,
      } as Bixby.Models.Profile;
    }
    return null;
  }

  private static findClaim(roles: string[], claim: string) {
    if (Bixby.Utils.isDefined(roles)) {
      const found = roles.find(role => role.toLowerCase() === claim.toLowerCase());
      return Bixby.Utils.isDefined(found);
    }
    return false;
  }
}
